module.exports = __webpack_public_path__ + "img/2019_S.e3911b23.png";